export default "__VITE_ASSET__14f2775c__"